import httpClient from "./httpClient";
// import Qs from "qs";
const getProjectList = () => httpClient.get(`/record/list-projects/current-user/?page_size=${100}`)
const getProjectListBYID = ({id:id, pageSize:pageSize}) => httpClient.get(`/record/list-projects/?page_size=${pageSize}&user_id=${id}`)
const getAllProjects = (pageSize) => httpClient.get(`/record/list-projects/?page_size=${pageSize}`)


const createProject = (params) => httpClient.post(`/record/create-project/`, params)
const addToProject = (params) => httpClient.post(`/record/add-users-to-project/`, params)


const getProjectOwner = () => httpClient.get(`/record/list-project-owner/`)

const detailProject = (id) => httpClient.get(`/record/detail-project/?project_id=${id}`)

const updateProject = (params) => httpClient.put(`/record/update-project/`, params)

const deleteProject = (id) => httpClient.delete(`/record/delete-project/?project_id=${id}`)

const deleteFromProject = (params) => httpClient.delete(`/record/delete-from-project/?user_id=${params.user_id}&project_id=${params.project_id}`)







export {
  getProjectList,
  getProjectListBYID,
  getAllProjects,
  // deleteFromProject,
  createProject,
  getProjectOwner,
  detailProject,
  updateProject,
  deleteProject,
  addToProject,
  deleteFromProject


}
